import React, { useState } from "react";
import axios from "axios";
import RegisterImage from "../assets/parking_register.svg";
import { Link } from "react-router-dom";

function AdminRegister() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobileNumber: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_API_URL}/admin/api/register`,
        formData
      );
      setMessage("✅ Registration successful!");
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        mobileNumber: "",
        password: "",
      });
    } catch (error) {
      setMessage(
        `❌ Error: ${error.response?.data?.message || "Failed to register"}`
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="adminRegister container">
        <div className="registerArea d-flex flex-column flex-lg-row col-12">
          <div className="registerImage w-100 w-lg-50 p-4">
            <img src={RegisterImage} alt="parking slots" />
          </div>
          <div className="registerForm w-100 w-lg-50 p-4">
            <h1>Create an Account</h1>
            <p>Register now to start your business.</p>
            {message && (
              <p className="alert alert-info">
                {message} <Link to="/adminLogin">Login Now!!!</Link>
              </p>
            )}
            <form onSubmit={handleSubmit}>
              <div className="d-flex flex-row justify-content-between mt-3">
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  placeholder="First name"
                  className="form-control col-lg-5"
                  required
                />
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  placeholder="Last name"
                  className="form-control col-lg-5 ml-3"
                  required
                />
              </div>
              <div className="d-flex flex-column mb-3">
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Your E-mail"
                  className="form-control mt-3"
                  required
                />
                <input
                  type="tel"
                  name="mobileNumber"
                  value={formData.mobileNumber}
                  onChange={handleChange}
                  placeholder="Your Mobile number"
                  className="form-control mt-3"
                  required
                />
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Your Password"
                  className="form-control mt-3"
                  required
                />
              </div>
              <div className="d-flex align-items-center mb-3">
                <input
                  type="checkbox"
                  id="showPassword"
                  checked={showPassword}
                  onChange={togglePasswordVisibility}
                  className="me-2"
                />
                <label htmlFor="showPassword" className="ml-2 text-white">
                  Show Password
                </label>
              </div>
              <div className="submit">
                <button
                  type="submit"
                  className="btn btn-primary w-100"
                  disabled={loading}
                >
                  {loading ? "Registering..." : "Register Now"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminRegister;
